// src/components/Testimonials.tsx
import { Avatar, Box, Grid, Rating, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';

const testimonials = [
  {
    name: 'Michael T.',
    role: 'Business Traveler',
    text: 'Botel saved my day when my flight was delayed. I was able to drop my luggage and explore the city instead of being stuck at the airport. The security gave me peace of mind!',
    rating: 5,
    avatarBg: '#232933',
  },
  {
    name: 'Amanda R.',
    role: 'Botel Host',
    text: "I've been making over $1,700 per month with just one Botel in my retail store. The best part? I don't have to do a thing - it's 100% automated and brings in new customers too!",
    rating: 5,
    avatarBg: '#FFD600',
  },
  {
    name: 'David L.',
    role: 'Early Investor',
    text: 'Investing in Botel was one of my smartest decisions. The growth potential is enormous, and the team is executing flawlessly. This is truly the future of smart storage.',
    rating: 5,
    avatarBg: '#22C55E',
  },
];

export default function Testimonials() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ 
      width: '100%', 
      bgcolor: '#20272D', 
      py: { xs: 4, sm: 6, md: 8, lg: 10 }, 
      px: { xs: 2, sm: 3, md: 4 },
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center' 
    }}>
      {/* Blue Badge */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: { xs: 1.5, sm: 2 } }}>
        <Box sx={{ 
          bgcolor: '#2563EB', 
          color: '#fff', 
          borderRadius: 2, 
          px: { xs: 2, sm: 2.5 }, 
          py: 0.5, 
          fontWeight: 700, 
          fontSize: { xs: 12, sm: 14 }, 
          letterSpacing: 1 
        }}>
          TESTIMONIALS
        </Box>
      </Box>
      {/* Heading */}
      <Typography 
        variant={isMobile ? 'h5' : isTablet ? 'h4' : 'h3'} 
        fontWeight={700} 
        align="center" 
        sx={{ 
          color: '#fff', 
          mb: { xs: 3, sm: 4, md: 5 }, 
          fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem', lg: '2.5rem' },
          lineHeight: 1.2,
          maxWidth: { xs: '100%', sm: '90%', md: '80%' }
        }}
      >
        See What Our Hosts & Travelers Are Saying
      </Typography>
      {/* Testimonial Cards */}
      <Grid 
        container 
        spacing={{ xs: 2, sm: 3, md: 4 }} 
        justifyContent="center" 
        sx={{ 
          maxWidth: 1200, 
          mx: 'auto',
          px: { xs: 1, sm: 2 }
        }}
      >
        {testimonials.map((t, i) => (
          <Grid size={{xs:12, sm:6, md:4}} key={i}>
            <Box sx={{ 
              bgcolor: '#181D23', 
              color: '#fff', 
              borderRadius: 4, 
              p: { xs: 3, sm: 4 }, 
              minHeight: { xs: 220, sm: 260 }, 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'flex-start', 
              boxShadow: 3,
              height: '100%'
            }}>
              <Stack 
                direction="row" 
                spacing={{ xs: 1.5, sm: 2 }} 
                alignItems="center" 
                sx={{ mb: { xs: 1.5, sm: 2 } }}
              >
                <Avatar sx={{ 
                  bgcolor: t.avatarBg, 
                  color: '#fff', 
                  width: { xs: 48, sm: 56 }, 
                  height: { xs: 48, sm: 56 }, 
                  fontSize: { xs: 24, sm: 28 } 
                }}>
                  {t.name[0]}
                </Avatar>
                <Stack direction="column" spacing={0.5}>
                  <Typography 
                    variant="subtitle2" 
                    fontWeight={700} 
                    sx={{ 
                      color: '#fff', 
                      fontSize: { xs: 14, sm: 16 } 
                    }}
                  >
                    {t.name}
                  </Typography>
                  <Typography 
                    variant="caption" 
                    sx={{ 
                      color: '#b0b8c1', 
                      fontSize: { xs: 12, sm: 14 } 
                    }}
                  >
                    {t.role}
                  </Typography>
                  <Rating 
                    value={t.rating} 
                    readOnly 
                    size="small" 
                    sx={{ 
                      color: '#FF6F61', 
                      mt: 0.5,
                      '& .MuiRating-icon': {
                        fontSize: { xs: 16, sm: 18 }
                      }
                    }} 
                  />
                </Stack>
              </Stack>
              <Typography 
                fontStyle="italic" 
                sx={{ 
                  color: '#e0e0e0', 
                  fontSize: { xs: 14, sm: 16 }, 
                  mt: 1,
                  lineHeight: 1.5,
                  flex: 1
                }}
              >
                "{t.text}"
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
